import { render, staticRenderFns } from "./FichaCrearProducto.vue?vue&type=template&id=7090cbf2"
import script from "./FichaCrearProducto.vue?vue&type=script&lang=js"
export * from "./FichaCrearProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports